import { render } from "./WorkEducationView.vue?vue&type=template&id=215ce756&scoped=true"
import script from "./WorkEducationView.vue?vue&type=script&lang=js"
export * from "./WorkEducationView.vue?vue&type=script&lang=js"

import "./WorkEducationView.vue?vue&type=style&index=0&id=215ce756&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-215ce756"]])

export default __exports__